export default {
  prepare: (val) => ({title: String(val)}),
}
